"use client";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Pencil } from "lucide-react";
import { t } from "@/lib/localization";

export default function EditVideoButton({ videoId }: { videoId: string }) {
    return (
        <a
            href={`/edit-video/${videoId}`}
            className={cn(buttonVariants({ size: "sm", variant: "secondary" }))}
        >
            <Pencil className="size-3.5 me-2" />
            {t("video-sheet.header.edit-btn", undefined, undefined)}
        </a>
    );
}
